import { useQuery } from "@tanstack/react-query"
import { frontAppIntegrationQuery } from "modules/settings/lib/frontapp/frontappIntegrationQuery"

export function useFrontAppIntegrationQuery(...args: Parameters<typeof frontAppIntegrationQuery>) {
  return useQuery(frontAppIntegrationQuery(...args))
}
